import {Injectable} from '@angular/core';

import { GoogleUser } from 'src/app/models/GoogleUser';
import { setItemInSessionStorage, getItemFromSessionStorage, GOOGLE_USER, ACCESS_TOKEN } from 'src/app/utils/SessionStorageUtil';

@Injectable({
  providedIn: 'root'
})
export class GoogleAuthenticationService {

  isAuthorized(): boolean {
    return getItemFromSessionStorage<string>(ACCESS_TOKEN) !== null;
  }

  getAccessToken() {
    return getItemFromSessionStorage<string>(ACCESS_TOKEN);
  }

  setAccessToken(token: string): void {
    setItemInSessionStorage(ACCESS_TOKEN, token);
  }

  setGoogleUser(user: GoogleUser) {
    setItemInSessionStorage(GOOGLE_USER, user);
  }

  getGoogleUser(): GoogleUser | null {
    return getItemFromSessionStorage<GoogleUser>(GOOGLE_USER);
  }
}
